import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import {
    CircularProgress,
    Fade,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField
} from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NotificationsActive } from '@material-ui/icons';
import { NotificationManager } from 'react-notifications';
import { validateWishListForm } from '../../utils/validators/validateForm';
class AddNewWishlistPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaderButton: false,
            closeVerification: false
        };
    }

    handleClose = () => {
        this.props.closePopup();
    };

    handleError = params => {
        this.setState(params);
    };
    addToWishlist = () => {
        const { name } = this.state;
        if (validateWishListForm({ name }, this.handleError)) {
            this.setState({ loaderButton: true });
            this.props.addNewtoWishlistAction(
                { name: this.state.name, providerId: this.props.data.id },
                this.onAddDone
            );
        }
    };

    onAddDone = (success, data) => {
        if (success) {
            NotificationManager.success(data.message, 'Success');
            this.handleClose();
        } else {
            NotificationManager.success(data.message, 'Error');
        }
    };
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: this.props.theme.palette.primary
                                .main,
                            color: '#ffffff',
                            fontSize: '16px'
                        }}
                        size="large"
                        onClick={this.addToWishlist}
                    >
                        <FormattedMessage
                            id="addThisProvider"
                            defaultMessage="Add this provider"
                        />
                    </Button>
                </div>
            );
        }
    };
    render() {
        const { data } = this.props;
        const { formatMessage } = this.props.intl;
        const { name, nameError, loaderButton } = this.state;
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/user/dashboard`
            });
        }
        return (
            <div>
                <Dialog
                    TransitionComponent={Fade}
                    className="service-modal verification-modal"
                    open={this.props.isVisible}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <div className=" log-in-pop-right p-0">
                        <form className="dialog-form  form-new">
                            <div
                                className="modal-header dir-pop-head"
                                style={{
                                    backgroundColor: this.props.theme.palette
                                        .primary.main
                                }}
                            >
                                <h3 className="dialog-heading">
                                    <FormattedMessage
                                        id="favouriteListName"
                                        defaultMessage="Favorite List Name"
                                    />
                                </h3>
                            </div>
                            <div className="modal-body dir-pop-body">
                                <DialogContent className="service-from-body mb-4">
                                    <TextField
                                        error={nameError ? true : false}
                                        helperText={nameError}
                                        label={formatMessage({
                                            id: 'List Name'
                                        })}
                                        id="name"
                                        fullWidth={true}
                                        name="name"
                                        type="text"
                                        value={name}
                                        onChange={event => {
                                            this.setState({
                                                name: event.target.value,
                                                nameError: ''
                                            });
                                        }}
                                        disabled={loaderButton}
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <div className="col-md-12 log-btn">
                                        {this.renderButton()}
                                    </div>
                                </DialogActions>
                            </div>
                        </form>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(null, actions)
);
export default composedHOC(injectIntl(withRouter(AddNewWishlistPopup)));



// WEBPACK FOOTER //
// ./src/components/Providers/AddNewWishlistPopup.js